import { Dayjs } from "dayjs";
import { Customer } from "..";

export type SingleDocument = {
  id: string;
  upload_date: string;
  document_type: string;
  remark: string;
  user_role: string;
  document_name: string;
  user_name: string;
  attachment_paths: string[] | null;
  // division: string;
  // section: string;
  // station: string;
  customers: Customer[];
  customer_name_list: string;
};

export type ResponseDocument = {
  id: string;
  upload_date: string;
  document_type: string;
  remark: string;
  user_role: string;
  document_name: string;
  user_name: string;
  attachment_paths: string[] | null;
  // division: string;
  // section: string;
  // station: string;
  customers: { id: string; zone: string; division: string; station: string }[];
};

export type DateFieldType = Dayjs | null;

export enum DocumentFieldType {
  Textfield = "textfield",
  Dropdown = "dropdown",
  Attachment = "attachment",
  REACTIVE_DROPDOWN = "reactive_dropdown",
  DateTime = "dateTime",
  Number = "number",
  Date = "date",
  URL = "url",
}

export type DocumentManagementFiltersType = {
  from_ts?: DateFieldType;
  end_ts?: DateFieldType;
  user_name: string;
  document_name: string;
  user_role: string;
  remarks: string;
  document_type: string[];
  section: string[];
  station: Customer[];
  // station: string;
  files?: File[];
  page: number;
  pageSize: number;
};
export type ReplacementDocumentManagementFiltersType = {
  from_ts?: DateFieldType;
  end_ts?: DateFieldType;
  user_name: string;
  document_name: string;
  user_role: string;
  remarks: string;
  document_type: string[];
  section: string[];
  // station: Customer[];
  station: string;
  files?: File[];
  page: number;
  pageSize: number;
};

export type DocumentManagementFormType = {
  document_name: string;
  document_type: string;
  files: File[];
  remarks: string;
  section: string;
  station: Customer[];
  issued_by: string | null;
  dateTime: Dayjs | null;
};

type FormTextField = {
  type: DocumentFieldType.Textfield;
  label: string;
  id: string;
  required: boolean | string;
  disabled?: boolean;
  placeholder?: string;
};

type FormNumberField = {
  type: DocumentFieldType.Number;
  label: string;
  id: string;
  required: boolean | string;
  disabled?: boolean;
  placeholder?: string;
};

type FormAutocompleteField = {
  type: DocumentFieldType.Dropdown;
  label: string;
  id: string;
  multiple: boolean;
  options: any[];
  required: boolean | string;
  disabled?: boolean;
};

export type FormReactiveAutocompleteField = {
  type: DocumentFieldType.REACTIVE_DROPDOWN;
  label: string;
  id: string;
  multiple: boolean;
  // options: any[];
  required: boolean | string;
  disabled?: boolean;
  reactive_key: string;
  get_options: (parent_value: any) => any[];
};

type FormAttachmentField = { type: DocumentFieldType.Attachment; id: string; required: boolean | string };

type FormDateTimeField = {
  type: DocumentFieldType.DateTime;
  label: string;
  id: string;
  required: boolean | string;
  disabled?: boolean;
  disallow_future_date?: boolean;
  custom_validation?: (value: any, form_values: any) => boolean | string;
};

type FormDateField = {
  type: DocumentFieldType.Date;
  label: string;
  id: string;
  required: boolean | string;
  disabled?: boolean;
  disallow_future_date?: boolean;
  custom_validation?: (value: any, form_values: any) => boolean | string;
};

type FormUrlField = {
  type: DocumentFieldType.URL;
  label: string;
  id: string;
  required: boolean | string;
  disabled?: boolean;
  placeholder?: string;
};

export type DocumentFormFieldType =
  | FormTextField
  | FormAttachmentField
  | FormAutocompleteField
  | FormReactiveAutocompleteField
  | FormDateTimeField
  | FormNumberField
  | FormUrlField
  | FormDateField;
